import $ from 'jquery'

class CareerCarousel {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		$(document).ready(function () {
			myObj.CareerCarouselFunction()
		})
	}

	//? 3. methods (functions)
	CareerCarouselFunction() {
		console.log('Carousel')

		let carouselTL = new TimelineMax({ repeat: -1, repeatDelay: 1 })
		carouselTL
			.add('start', 0)
			.set('.carousel-img', { scale: 1.1 })
			.staggerFrom('.carousel-img', 1, { opacity: 0 }, 4.5, 'start')
			.staggerFrom(
				'.carousel-img',
				5,
				{ scale: 1, ease: 'expo.out' },
				5,
				'start'
			)
	}
}

export default CareerCarousel
